import { render, staticRenderFns } from "./TriggersOverview.vue?vue&type=template&id=1309b17b&"
import script from "./TriggersOverview.vue?vue&type=script&lang=ts&"
export * from "./TriggersOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports